import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import "rxjs/add/operator/take";
import { AuthenticationService } from "../store/auth/authentication.service";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable()
export class AlreadyLoggedGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      tap((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          console.log("already logged, go to dashboard...");
          this.router.navigate(["/dashboard"]);
        }
      }),
      map((isAuthenticated) => !isAuthenticated),
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/guards/already-logged.guard.ts